// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3y7zd","content":"LayoutSettings_content__dtbMq"};